import CommunicationConversations from "./communication-conversations";

export default CommunicationConversations;